import type { AssistantInputAction } from '@triedge/ai-assistant-ui';

export const assistantInputActions: AssistantInputAction[] = [
  {
    id: 'navigate',
    label: 'Navigate',
    description: 'Ask the assistant to open a specific page or flow.',
    type: 'navigate',
    input: {
      type: 'select',
      placeholder: 'Choose a destination',
      options: [
        { label: 'School Workspace', value: '/' },
        { label: 'Admissions', value: '/admin/admissions' },
        { label: 'Financial Aid', value: '/admin/financial-aid' },
        { label: 'Settings', value: '/admin/settings' },
      ],
    },
    promptTemplate: 'Navigate to [{{label}}]({{value}}).',
    actionLabel: 'Send request',
  },
];
